import { base_url } from "Constants";
import httpService from 'services/httpService.js';
import { SaveVideoStats } from "./videoStats";
import log from "loglevel";


var myInterval, logged_in;

// $(window).on('beforeunload', function (e) {
//     if (e.originalEvent)
//     {
//         if(logged_in){
//             if (localStorage.ab_c > 0) {
//                 SaveData();
//             }
//             if (window.name!==""){
//                 wName = window.name;
//                 window.name = "";
//                 SaveVideoStats(null, wName);
//             }
//         }
//     }
//     $(this).trigger('beforeunload');
// });

const beforeunload_listener = function (e, sendBeacon) {
    log.log("Executing beforeunload event", sendBeacon);
    if (e) {
        if (logged_in) {
            if (localStorage.ab_c > 0) {
                SaveData(null, "From beforeunload", sendBeacon);
            }
            if (window.name !== "") {
                var wName = window.name;
                // window.name = ""; caused the pause-resume freeze: SaveVideoStats only
                // restores the flag when it ends in "-1", so a hide while paused ("-0")
                // left window.name empty and the play handler rebuilt it as invalid "1"
                SaveVideoStats(null, wName, sendBeacon);
            }
        }
    }
}

function timerHandler() {
    // log.log("Calling timerHandler: this was set in startTimer to run every second");
    localStorage.ab_c = Number(localStorage.ab_c) + 1;
    var today = new Date();
    var temp_today = today.getFullYear() + "-" +
        (today.getMonth() + 1) + "-" +
        today.getDate();

    var localStorage_datetime = new Date(localStorage.ab_d);
    var localStorage_date = localStorage_datetime.getFullYear() + "-" +
        (localStorage_datetime.getMonth() + 1) + "-" +
        localStorage_datetime.getDate();
    // log.log("timerHandler: localStorage.ab_c", localStorage.ab_c)
    if ((today.getMinutes() === 0 && today.getSeconds() === 0) || (localStorage_datetime.getHours() !== today.getHours())) {
        SaveData("AfterOneHour", "from timerHandler - AfterOneHour");
    }
    else if (localStorage.ab_c === "300") {
        SaveData(null, "from timerHandler - 300");
    }
    else if (temp_today !== localStorage_date) {
        SaveData(null, "from timerHandler - temp_today !== localStorage_date");
    }
    else if (localStorage.ab_c > 300) {
        localStorage.ab_c = 0;
        localStorage.ab_d = new Date().toUTCString();
    }
    else {
        localStorage.ab_d = new Date().toUTCString();
    }
}

function startTimer(_message) {
    // log.log("Executing startTimer, load/focus event", message, logged_in, document.visibilityState);
    if (logged_in) {
        if (document.visibilityState === "visible") {
            if (!myInterval) {
                if (!localStorage.ab_c) {
                    localStorage.ab_c = 0;      // ab_c means Active time in Bodhitree Counts
                }

                if (!localStorage.ab_d) {
                    localStorage.ab_d = new Date().toUTCString();   // ab_d means Active time in Bodhitree Date
                }

                localStorage.ia_t = "1";         // iAT means inactive timer
                myInterval = window.setInterval(timerHandler, 1000);
            }
        }
    }
}

function stopTimer() {
    log.log("Executing stopTimer, blur event", logged_in, document.visibilityState);
    if (logged_in) {
        window.clearInterval(myInterval);
        myInterval = null;
        localStorage.ia_t = "0";
    }
}

//Function to save data on server after every 5 minutes, after window close, after logout
async function SaveData(logout = null, message, sendBeacon) {
    log.log("Called saveData with ", message);
    var cnt = localStorage.ab_c;
    var dt = localStorage.ab_d;
    localStorage.ab_c = 0;
    localStorage.ab_d = new Date().toUTCString();
    var url = '/statistics/activehours/?format=json';
    let data = { 'seconds': cnt, 'date': dt, 'logout': logout };
  
    if (sendBeacon) {
      log.log("Executing sendBeacon", data);
      data['token'] = localStorage.token && localStorage.token.split("Token ")[1];
      navigator.sendBeacon(base_url + url, JSON.stringify(data));
      log.log("Executed sendBeacon", data);
    } else {
      try {
        const response = await httpService.post(url, data, {
          headers: {
            // 'X-CSRFToken': Cookies.get('csrftoken')
          }
        });
        if (logout && logout !== "AfterOneHour") {
          // window.location = document.getElementById('logoutUser').href; // what is this for?
        }
      } catch (response) {
        log.log(response);
        if (logout && logout !== "AfterOneHour") {
          // window.location = document.getElementById('logoutUser').href; // what is this for?
        }
      }
    }
}

export function logout_listener() {
    log.log("Logout executing", logged_in);
    if (logged_in) {
        if (localStorage.ab_c > 0) {
            if (window.name !== "") {
                SaveVideoStats();
            }

            SaveData("True", "From logoutUser", true);
            return false;
        }
    }
}

const visibilityChangeListener = function (e) {
    log.log("Visibility Listener: ", document.visibilityState);
    if (document.visibilityState === "hidden") {
        beforeunload_listener(e, true);
    } else if (document.visibilityState === "visible") {
        startTimer("From visile ");
    }
}

export function initializeStatistics() {
    removeEventListeners();

    myInterval = null;
    // var logged_in = document.getElementById("activeHrsScript")?.getAttribute("data-logged_in");
    logged_in = localStorage.token;
    // log.log({ "Running stats": logged_in });

    if (logged_in) {
        httpService.defaults.headers.Authorization = logged_in;
    }

    // window.addEventListener('beforeunload', beforeunload_listener);
    // log.log("Added beforeunload listener on window");
    // window.addEventListener('load', function () { startTimer("From load") });
    // log.log("Added load listener on window");
    // window.addEventListener('focus', function () { startTimer("From focus") });
    // log.log("Added focus listener on window");
    document.addEventListener("visibilitychange", visibilityChangeListener);
    log.log("Added visibility change listener on documnent")
    // window.addEventListener('blur', stopTimer);
    // log.log("Added blur listener on window");
    startTimer("Initial")

    // Note: The following line triggers the 'beforeunload' event in the jQuery code.
    // However, in the equivalent plain JavaScript code, it's unnecessary and can be omitted.
    // The 'beforeunload' event will be automatically triggered when the window is being unloaded.
    // $(this).trigger('beforeunload');

    log.log("Logout event handler adding: ", document.getElementById("logoutUser"));
    if (!!document.getElementById("logoutUser")) {
        log.log("Adding onclick to logoutUser")
        document.getElementById("logoutUser").onclick = logout_listener;
    }
}

export function removeEventListeners() {
    window.removeEventListener('beforeunload', beforeunload_listener);
    log.log("Removed beforeunload listener on window");
    window.removeEventListener('load', startTimer);
    log.log("Removed load listener on window");
    window.removeEventListener('focus', startTimer);
    log.log("Removed focus listener on window");
    window.removeEventListener('blur', stopTimer);
    log.log("Removed blur listener on window");
    document.removeEventListener("visibilitychange", visibilityChangeListener);
    log.log("Removed visibilitychange listener on window");
    if (myInterval) {
        clearInterval(myInterval);
    }
}